/**
 * Utilitário de logging condicional
 * Só loga em desenvolvimento, silencia em produção
 */

const isDev = process.env.NODE_ENV === 'development';

export const logger = {
  log: (...args: any[]) => {
    if (isDev) console.log(...args);
  },
  warn: (...args: any[]) => {
    if (isDev) console.warn(...args);
  },
  error: (...args: any[]) => {
    // Erros sempre são logados (importantes para debug)
    console.error(...args);
  },
  debug: (...args: any[]) => {
    if (isDev) console.debug('[DEBUG]', ...args);
  },
  info: (...args: any[]) => {
    if (isDev) console.info(...args);
  },
  // Para logs de API (mais detalhados)
  api: (...args: any[]) => {
    if (isDev) console.log('[API]', ...args);
  },
};

export default logger;
